<template>
    <v-row>
        <v-col v-for="detail in details.data" :key="detail.id" cols="12">
            <v-card flat align="center" class="card dt-border">
                <v-row class="hover" style="overflow-x:auto;flex-wrap:nowrap;" align="center" @click="$router.push(`/customers/${detail.user.id}`)">
                    <v-col v-if="detail.user && detail.user.profile">
                        <span>{{detail.user.profile.firstname + ' ' + detail.user.profile.lastname}}</span>
                    </v-col>
                    <v-col v-else>Null</v-col>
                    <v-col>
                        <span v-if="detail.transactiontype == 'credit'" class="green--text">{{detail.transactiontype}}</span>
                        <span v-if="detail.transactiontype == 'debit'" class="orange--text">{{detail.transactiontype}}</span>
                    </v-col>
                    <v-col>
                        <span>{{detail.reference}}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatMoney(detail.amount) }}</span>
                    </v-col>
                    <v-col v-if="detail.bankAccount">
                        <span>{{detail.bankAccount.bankName}} - {{detail.bankAccount.nuban}} - {{detail.bankAccount.accountName}} </span>
                    </v-col>
                    <v-col>
                        <span>{{ formatDate(detail.created) }}</span>
                    </v-col>
                    <v-col>
                        <v-chip color="grey" dark>
                            {{ detail.slug }}
                        </v-chip>
                    </v-col>
                    <v-col>
                        <v-chip v-if="detail.status == 'successful'" dark class="ma-2" color="green">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'pending'" dark class="ma-2" color="orange">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'failed'" dark class="ma-2" color="red">
                            {{detail.status}}
                        </v-chip>
                    </v-col>
                    <v-col md="1">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                v-bind="attrs"
                                v-on="on"
                                color="#797979"
                                icon
                                >
                                <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list class="align-center justify-center text-center" style="width:150px;padding:10px" flat>
                                <v-list-item @click="action(detail,'reverseDialog')" class="rounded justify-center table_link " link>
                                    <v-icon class="mr-2">
                                        mdi-cash-refund
                                    </v-icon>
                                    <p class="mb-0">Reverse</p>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <reverse-modal @reload="reload" @closeModal="reverseDialog = false" v-if="reverseDialog" :dialog="reverseDialog" :detail="detail" />
    </v-row>
</template>

<script>
import ReverseModal from './reverse-modal.vue';
// ============== IMPORT SERVICES ============
import {formatMoney} from '@/utils/moneyFormatter';

export default {
    props:{
        details:{
            type : Object
        }
    },
    data:()=> ({
        detail : {},
        reverseDialog : false
    }),
    components:{
        ReverseModal
    },
    methods:{
        formatMoney(amount){
            return formatMoney(amount)
        },
        async action(data,modal){
            this.detail = await data;
            this[modal] = true
        },
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
            });
            return reModelDate;
        },
        reload(){
            this.$emit('reload')
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.table_link{
    transition: 0.5s;
    &:hover{
        background:rgba(209, 87, 26, 0.13);
        p,i{
            color: var(--orange);
        }
        
    }
}

.hover:hover{
    cursor: pointer;
    background-color: rgb(238,238,238);
}
</style>